<template>
  <div class="textareaContacts relative">
    <div class="relative">
      <textarea
        class="textarea-custom"
        :class="{empty: value === ''}"
        :type="type"
        :name="name"
        :autocomplete="autocomplete"
        :value="value"
        :autofocus="autofocus"
        :ref="focus ? name : false"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur')"
        @keyup.enter="$emit('keyup.enter', $event.target.value)"
        @keyup="$emit('keyup', $event)"
      />
      <label>
        {{ placeholder }}
      </label>
    </div>

    <ValidationMessages v-if="validations" :validations="validations" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'

export default {
  name: 'BaseTextareaContacts',
  components: {
    ValidationMessages
  },
  data () {
    return {
      iconActive: false,
      icon: 'visibility'
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    focus: {
      type: Boolean,
      required: false,
      default: false
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    validations: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    if (this.focus) {
      this.$refs[this.name].focus()
    }
  }
}
</script>
<style lang="scss">
 .textareaContacts {
   height: 141px;
 }
</style>
<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';

  $color-tertiary: color(tertiary);
  $color-black: color(black);
  $color-puerto-rico: color(puerto-rico);
  $color-hover: color(tertiary, $colors-background);

  /*<!--textarea {-->*/
  /*<!--  &:hover,-->*/
  /*<!--  &:focus {-->*/
  /*<!--    outline: none;-->*/
  /*<!--    border-color: $color-puerto-rico;-->*/
  /*<!--  }-->*/
  /*<!--  resize: none;-->*/
  /*<!--  background: inherit;-->*/
  /*<!--  min-height: 100px;-->*/
  /*<!--}-->*/

  label {
    color: #999;
    position: absolute;
    pointer-events: none;
    left: 10px;
    top: 10px;
    transition: 0.2s ease all;
  }

  textarea:focus ~ label,
  textarea:not(.empty) ~ label {
    top: 0;
    font-size: 14px;
    color: $color-puerto-rico;
  }

  .icon {
    right: 6px;
    top: 10px;
    &:hover,
    &:focus {
      color: $color-hover;
    }
  }
.textarea-custom {
    width: 94.5%;
    height: 90px;
    resize: none;
    border-radius: 5px;
    border: solid 1px #bdbdbd;
    background-color: #ffffff;
    font-family: 'TTNorms Regular', sans-serif;
    padding: 15px;
    font-size: 16px;
    @media (max-width: 1200px) {
      width: 96.5%;
    }
  @media (max-width: 990px) {
    width: 95.5%;
  }
    @media (max-width: 768px) {
      width: 94%;
    }
    @media (max-width: 500px) {
      width: 93%;
    }
    @media (max-width: 375px) {
      width: 90%;
    }
  }
</style>
